class Search {

	constructor() {
		this.initialize();
	}

	initialize() {

		$('[data-search-slide]').on('click', function(e) {
			$('[data-search-form]').slideToggle(300);

			e.preventDefault();
		});

		$(document).mouseup(function(e) {
			let search = $('[data-search]');
			let suggestions = $('[data-suggestions]');

			if (!search.is(e.target) && !suggestions.is(e.target) && suggestions.has(e.target).length === 0) {
				suggestions.hide();
			}
		});

		$(window).resize(function() {
			$('[data-search-form]').removeAttr('style');
		});

		if($('[data-search]').length) {
			let searchRequest = $('[data-search]').val();
			if (searchRequest.length > 0) {
				$('[data-search-form]').show();
			}
		}
	}

}

new Search();
